export const SMALL_BREAKPOINT = {
  max: 767,
};
export const MEDIUM_BREAKPOINT = {
  min: 768,
  max: 1024,
};
export const LARGE_BREAKPOINT = { min: 1025 };
export const SMALL_OUTFIT = 'small' as 'small';
export const MEDIUM_OUTFIT = 'medium' as 'medium';
export const BIG_OUTFIT = 'big' as 'big';
export const COMPRESSED_OUTFIT = 'compressed' as 'compressed';

export enum SCREEN_BREAKPOINT_NAMES {
  'small' = 'small',
  'medium' = 'medium',
  'large' = 'large',
}

export const COLORS = {
  white: 'rgb(255, 255, 255)',
};
